import Header from "../components/Header";
import Footer from "../components/Footer";
import { useState } from "react";
import { Outlet } from "react-router-dom";
function Layout({children}) {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [inProgress, setInProgress] = useState(false)
//   const [points,setPoints] = useState();
 return (
    <div>
      <Header
      />
      
      <main>
        <Outlet />         
      </main>
      
      <Footer />
    </div>
  );
}

export default Layout;